import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ChartBarIcon, PlusIcon } from '@heroicons/react/24/outline';
import { api } from '../../services/api';

const Progress: React.FC = () => {
  const { data: progressData, isLoading } = useQuery({
    queryKey: ['progress'],
    queryFn: () => api.get('/progress'),
  });

  const progress = progressData?.data?.progress || [];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Progress</h1>
          <p className="text-gray-600">Track your fitness journey</p>
        </div>
        <div className="mt-4 sm:mt-0">
          <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
            <PlusIcon className="h-5 w-5 mr-2" />
            Log Progress
          </button>
        </div>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          {progress.length > 0 ? (
            <div className="space-y-4">
              {progress.map((entry: any) => (
                <div
                  key={entry.id}
                  className="flex items-center justify-between p-4 bg-gray-50 rounded-lg"
                >
                  <div className="flex items-center">
                    <ChartBarIcon className="h-8 w-8 text-blue-500 mr-4" />
                    <div>
                      <h3 className="text-lg font-medium text-gray-900 capitalize">
                        {entry.type}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {entry.value} {entry.unit} • {new Date(entry.date).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                  {entry.category && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {entry.category}
                    </span>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <ChartBarIcon className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-sm font-medium text-gray-900">No progress entries</h3>
              <p className="mt-1 text-sm text-gray-500">
                Get started by logging your first progress entry.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Progress;
